import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import Checkbox from "../Checkbox";
import {rolesStorage} from "../../services/rolesStorage";
import {ErrorHandler} from "../ErrorHandler";
import {USER_REQUEST_URL, postFetchRequest} from "../../store/requests";
import {errorCallback, makeUrl} from "../../util";

const UsersTable = ({usersList, setUsersList = null, isTab, handleChange = null, findCheckedValues = null}) => {
    const { i18n } = useTranslation();
    const visibleUsers = useMemo(() => {
        if (!usersList?.length) {
            return [];
        }
        return isTab ? usersList : usersList.slice(0, 4);
    }, [usersList, isTab]);

    const updateLoginWithTGBot = (userId, isChecked) => {
        if (!setUsersList) {
            return;
        }
        setUsersList((prevUsers) => prevUsers.map((user) => (
            user.id === userId ? {...user, loginWithTGBot: isChecked} : user
        )));
    };

    const handleChangeLogin = (userId, isChecked) => {
        updateLoginWithTGBot(userId, isChecked);
        postFetchRequest(
            makeUrl([USER_REQUEST_URL, userId, "/"]),
            {"canLoginWithTGBot": isChecked},
            () => {},
            (err) => {
                updateLoginWithTGBot(userId, !isChecked);
                errorCallback(err);
            },
            true,
        );
    };
    try {
        return (
            <table className="block__table users__table">
                <thead>
                <tr className="users__table-header">
                    {isTab ? <th></th> : null}
                    <th className={`users__table-item ${isTab ? 'users__table-item_sticky users__table-item_modal' : ''}`}>
                        {i18n.t('app.page.user.name')}/id
                    </th>
                    <th className={`users__table-item ${isTab ? 'users__table-item_sticky users__table-item_modal' : ''}`}>
                        {i18n.t('app.page.user.phone')}/{i18n.t('app.page.user.post')}
                    </th>
                    {isTab && (
                        <th className={`users__table-item ${isTab ? 'users__table-item_sticky users__table-item_modal' : ''}`}>
                            {i18n.t('app.page.user.login.tg-admin-bot')}
                        </th>
                    )}
                    <th className={`users__table-item ${isTab ? 'users__table-item_sticky users__table-item_modal' : ''}`}>
                        {i18n.t('app.page.user.role')}
                    </th>
                </tr>
                </thead>
                <tbody>
                {visibleUsers.map((it) =>
                    <tr className="users__table-row" key={it.id}>
                        {isTab ?
                            <td className="users__tab-checkbox">
                                <Checkbox handleChecked={() => handleChange(it)} checked={findCheckedValues(it.id)}/>
                            </td>
                            :
                            null}
                        <td className="users__table-item">
                            {it.name}
                            {it.name && !isTab ? null : <p className={isTab ? "block__bullet users__tab-id users__tab-content" : "users__tab-data"}>{it.id}</p>}
                        </td>
                        <td className="users__table-item">
                            {it.phone}
                            {it.phone && !isTab ? null : <p className={isTab ? "users__tab-content" : "users__tab-data"}>{it.email}</p>}
                        </td>
                        {
                            isTab && (
                                <td className="users__tab-checkbox">
                                    <Checkbox handleChecked={(checked) => handleChangeLogin(it.id, checked)} checked={!!it.loginWithTGBot}/>
                                </td>
                            )
                        }
                        <td className="users__table-item">{i18n.t(`appRoles.scheme.userRoles.${rolesStorage.getRoleById(it.appRole).code}`)}</td>
                    </tr>
                )}
                </tbody>
            </table>
        );
    } catch(err) {
        return <ErrorHandler
            titleValue={i18n.t('app.page.profile.emptyData')}/>;
    }
};

export default UsersTable;
